module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit-main"
  }, [_c('div', {
    staticClass: "page-contain edit-meeting-plan"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.addNewOrEditData,
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "会议名称",
      "prop": "meetingName"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "placeholder": "请输入会议名称"
    },
    model: {
      value: (_vm.addNewOrEditData.meetingName),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingName", $$v)
      },
      expression: "addNewOrEditData.meetingName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "prop": "meetingSystem"
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("系统选择"), _c('common-tooltip', {
    attrs: {
      "tipCode": "8"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择（可多选）"
    },
    model: {
      value: (_vm.addNewOrEditData.meetingSystem),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingSystem", $$v)
      },
      expression: "addNewOrEditData.meetingSystem"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingSystem), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "是否网络会议",
      "prop": "meetingModality"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.meetingModality),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingModality", $$v)
      },
      expression: "addNewOrEditData.meetingModality"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingModality), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "会议性质",
      "prop": "meetingProp"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleMeetingPropChange
    },
    model: {
      value: (_vm.addNewOrEditData.meetingProp),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingProp", $$v)
      },
      expression: "addNewOrEditData.meetingProp"
    }
  }, _vm._l((_vm.meetingPropAndTypeArrays.selectMeetingProp), function(item) {
    return _c('el-option', {
      key: item.itemValue,
      attrs: {
        "value": item.itemValue,
        "label": item.itemText
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), (_vm.meetingSystemType != 'GSD') ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "A1会议类型",
      "prop": "meetingType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleMeetingTypeChange
    },
    model: {
      value: (_vm.addNewOrEditData.meetingType),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingType", $$v)
      },
      expression: "addNewOrEditData.meetingType"
    }
  }, _vm._l((_vm.filterMeetingType), function(item) {
    return _c('el-option', {
      key: item.itemValue,
      attrs: {
        "value": item.itemValue,
        "label": item.itemText
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addNewOrEditData.meetingType === '24' && _vm.isCEDepart()) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "是否为GSD",
      "prop": "isGsd"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addNewOrEditData.isGsd),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "isGsd", $$v)
      },
      expression: "addNewOrEditData.isGsd"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.meetingSystemType != 'A1') ? _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "GSD项目类型",
      "prop": "meetingGsdType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.meetingGsdSubType = ''
      }
    },
    model: {
      value: (_vm.addNewOrEditData.meetingGsdType),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingGsdType", $$v)
      },
      expression: "addNewOrEditData.meetingGsdType"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingGsdType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "GSD细类",
      "prop": "meetingGsdSubType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.meetingGsdSubType),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingGsdSubType", $$v)
      },
      expression: "addNewOrEditData.meetingGsdSubType"
    }
  }, _vm._l((_vm.MeetingGsdSubTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "部门",
      "prop": "departId"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleDepartChange
    },
    model: {
      value: (_vm.addNewOrEditData.departId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "departId", $$v)
      },
      expression: "addNewOrEditData.departId"
    }
  }, _vm._l((_vm.baseDataRecords.Depart), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "Franchise/DA",
      "prop": "medicalField"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.teamL4 = '';
        _vm.resetRelativeFields()
      }
    },
    model: {
      value: (_vm.addNewOrEditData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "medicalField", $$v)
      },
      expression: "addNewOrEditData.medicalField"
    }
  }, _vm._l((_vm.getMedicalFieldArray(_vm.addNewOrEditData.departId, false)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "团队",
      "prop": "teamL4"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.resetRelativeFields
    },
    model: {
      value: (_vm.addNewOrEditData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "teamL4", $$v)
      },
      expression: "addNewOrEditData.teamL4"
    }
  }, _vm._l((_vm.getTeamArray(_vm.addNewOrEditData.departId, _vm.addNewOrEditData.medicalField, false)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [(_vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp) == '推广') ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "治疗领域",
      "prop": "treatmentArea"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    on: {
      "change": function($event) {
        return _vm.handleAreaChange()
      }
    },
    model: {
      value: (_vm.addNewOrEditData.treatmentArea),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "treatmentArea", $$v)
      },
      expression: "addNewOrEditData.treatmentArea"
    }
  }, _vm._l((_vm.areaRelationObject[_vm.addNewOrEditData.meetingProp]), function(item) {
    return _c('el-option', {
      key: item.areaDbId,
      attrs: {
        "value": item.areaDbId,
        "label": item.areaName
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp).indexOf('非推广') >= 0) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "疾病领域",
      "prop": "diseaseArea"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    on: {
      "change": function($event) {
        return _vm.handleAreaChange()
      }
    },
    model: {
      value: (_vm.addNewOrEditData.diseaseArea),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "diseaseArea", $$v)
      },
      expression: "addNewOrEditData.diseaseArea"
    }
  }, _vm._l((_vm.areaRelationObject[_vm.addNewOrEditData.meetingProp]), function(item) {
    return _c('el-option', {
      key: item.areaDbId,
      attrs: {
        "value": item.areaDbId,
        "label": item.areaName
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "产品",
      "prop": "productId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择（可多选，可搜索）"
    },
    on: {
      "change": _vm.resetRelativeFields
    },
    model: {
      value: (_vm.addNewOrEditData.productId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "productId", $$v)
      },
      expression: "addNewOrEditData.productId"
    }
  }, _vm._l((_vm.productArray), function(item) {
    return _c('el-option', {
      key: item.productDbId,
      attrs: {
        "value": item.productDbId,
        "label": item.productName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "公司战略",
      "prop": "companyStrategy"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择（可多选）"
    },
    model: {
      value: (_vm.addNewOrEditData.companyStrategy),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "companyStrategy", $$v)
      },
      expression: "addNewOrEditData.companyStrategy"
    }
  }, _vm._l((_vm.baseDataRecords.CompanyStrategy), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "策略重点",
      "prop": "strategyKeynote"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择（可多选，可搜索）"
    },
    model: {
      value: (_vm.addNewOrEditData.strategyKeynote),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "strategyKeynote", $$v)
      },
      expression: "addNewOrEditData.strategyKeynote"
    }
  }, [_vm._l((_vm.filterStrategy), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": ((item.productName) + " - " + (item.keynote))
      }
    })
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "999999",
      "label": "其他/不适用"
    }
  })], 2)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": _vm.meetingSystemType != 'A1',
      "label": "治疗领域业务结果",
      "prop": "medicalFieldResult"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择（可多选，可搜索）"
    },
    model: {
      value: (_vm.addNewOrEditData.medicalFieldResult),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "medicalFieldResult", $$v)
      },
      expression: "addNewOrEditData.medicalFieldResult"
    }
  }, [_vm._l((_vm.filterDomainResult), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": ((item.productName) + " - " + (item.treatAreaResult))
      }
    })
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "999999",
      "label": "其他"
    }
  })], 2)], 1)], 1), _vm._v(" "), (_vm.addNewOrEditData.medicalFieldResult.join(',').indexOf('999999') >= 0) ? _c('el-col', [_c('el-form-item', {
    staticClass: "medicalFieldResultDesItem",
    attrs: {
      "label": "治疗领域业务结果（自定义描述）",
      "prop": "medicalFieldResultDes"
    }
  }, [_c('el-input', {
    staticClass: "medicalFieldResultDes",
    attrs: {
      "rows": "1",
      "maxlength": "200",
      "type": "textarea",
      "placeholder": "请输入业务结果描述"
    },
    model: {
      value: (_vm.addNewOrEditData.medicalFieldResultDes),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "medicalFieldResultDes", $$v)
      },
      expression: "addNewOrEditData.medicalFieldResultDes"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "开始日期",
      "prop": "meetingBeginDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "default-value": _vm.seasonStartDate,
      "picker-options": _vm.startPickerOptions,
      "type": "date",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.meetingBeginDate),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingBeginDate", $$v)
      },
      expression: "addNewOrEditData.meetingBeginDate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "结束日期",
      "prop": "meetingEndDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "default-value": _vm.addNewOrEditData.meetingBeginDate,
      "picker-options": _vm.endPickerOptions,
      "type": "date",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.meetingEndDate),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingEndDate", $$v)
      },
      expression: "addNewOrEditData.meetingEndDate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "会议时段",
      "prop": "meetingTimeInt"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.meetingTimeInt),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingTimeInt", $$v)
      },
      expression: "addNewOrEditData.meetingTimeInt"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingTimeInt), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "国家",
      "prop": "country"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleCountryChange
    },
    model: {
      value: (_vm.addNewOrEditData.country),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "country", $$v)
      },
      expression: "addNewOrEditData.country"
    }
  }, _vm._l((_vm.baseDataRecords.Country), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "省份",
      "prop": "province"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请先选择国家"
    },
    on: {
      "change": _vm.handleProvinceChange
    },
    model: {
      value: (_vm.addNewOrEditData.province),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "province", $$v)
      },
      expression: "addNewOrEditData.province"
    }
  }, _vm._l((_vm.remoteProvinceData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "城市",
      "prop": "city"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请先选择省份"
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.cityName = _vm.getName(_vm.addNewOrEditData.city, _vm.remoteCitiesData, 'id', 'name');
        _vm.clearHospital()
      }
    },
    model: {
      value: (_vm.addNewOrEditData.city),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "city", $$v)
      },
      expression: "addNewOrEditData.city"
    }
  }, _vm._l((_vm.remoteCitiesData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": _vm.meetingSystemType != 'GSD' && _vm.basedataGetName('MeetingModality', _vm.addNewOrEditData.meetingModality).indexOf('线下') >= 0,
      "label": "会议地点",
      "prop": "meetingPlace"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "placeholder": "请输入会议地点"
    },
    model: {
      value: (_vm.addNewOrEditData.meetingPlace),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingPlace", $$v)
      },
      expression: "addNewOrEditData.meetingPlace"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "meeting-place-tip"
  }, [_vm._v("原则上，不得在餐厅或酒吧等以餐饮、休闲娱乐为主要目的的场所举办学术会议。")])], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [(_vm.meetingSystemType != 'A1') ? _c('el-row', [_c('div', {
    staticClass: "col-full"
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "受赠方类型(GSD系统)"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.recipientSocietyOrHospital),
      callback: function($$v) {
        _vm.recipientSocietyOrHospital = $$v
      },
      expression: "recipientSocietyOrHospital"
    }
  }, [_c('el-radio', {
    staticClass: "tooltip-header-text",
    attrs: {
      "label": 1
    }
  }, [_vm._v("受赠学会"), _c('common-tooltip', {
    attrs: {
      "tipCode": "11"
    }
  })], 1), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("医院")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("大学")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("患者组织")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("其他")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.meetingSystemType != 'A1' && _vm.recipientSocietyOrHospital) ? _c('el-row', {
    staticClass: "recipientSociety-input"
  }, [_c('el-col', [(_vm.recipientSocietyOrHospital == 1) ? _c('el-form-item', {
    attrs: {
      "prop": "recipientSocietyStr"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入学会名称(必填)"
    },
    model: {
      value: (_vm.addNewOrEditData.recipientSocietyStr),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "recipientSocietyStr", $$v)
      },
      expression: "addNewOrEditData.recipientSocietyStr"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.recipientSocietyOrHospital == 2) ? _c('el-form-item', {
    attrs: {
      "prop": "universityStr"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入大学名称(必填)"
    },
    model: {
      value: (_vm.addNewOrEditData.universityStr),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "universityStr", $$v)
      },
      expression: "addNewOrEditData.universityStr"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.recipientSocietyOrHospital == 3) ? _c('el-form-item', {
    attrs: {
      "prop": "patientOrgStr"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入患者组织名称(必填)"
    },
    model: {
      value: (_vm.addNewOrEditData.patientOrgStr),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "patientOrgStr", $$v)
      },
      expression: "addNewOrEditData.patientOrgStr"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.recipientSocietyOrHospital == 4) ? _c('el-form-item', {
    attrs: {
      "prop": "otherStr"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入其他名称(必填)"
    },
    model: {
      value: (_vm.addNewOrEditData.otherStr),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "otherStr", $$v)
      },
      expression: "addNewOrEditData.otherStr"
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.meetingSystemType == 'A1' || !_vm.recipientSocietyOrHospital) ? _c('div', [_c('el-row', [(!_vm.isOneHospital()) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "医院总数"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.moreThenOneHospital),
      callback: function($$v) {
        _vm.moreThenOneHospital = $$v
      },
      expression: "moreThenOneHospital"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("一家")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("两家及以上")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    staticClass: "more-tab"
  }, [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "prop": "hospitalLevelId"
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("医院层级"), _c('common-tooltip', {
    attrs: {
      "tipCode": "9"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.hospitalLevelId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "hospitalLevelId", $$v)
      },
      expression: "addNewOrEditData.hospitalLevelId"
    }
  }, _vm._l((_vm.filterHospitalLevel), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.hospitalLevel,
        "disabled": item.typeId === _vm.disableHospitalType || _vm.isSelectedHospitalLevel(item.id)
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), (_vm.moreThenOneHospital && !_vm.isOneHospital()) ? _c('el-col', {
    staticClass: "col-add-remove"
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "医院数量",
      "prop": "hospitalCount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "placeholder": "请输入医院数量",
      "controls": false,
      "precision": 0,
      "min": 1
    },
    model: {
      value: (_vm.addNewOrEditData.hospitalCount),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "hospitalCount", $$v)
      },
      expression: "addNewOrEditData.hospitalCount"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-add-remove"
  }, [_c('i', {
    staticClass: "iconfont icon-tianjia1",
    on: {
      "click": _vm.AddNewHospitalInfo
    }
  })])], 1) : _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "医院",
      "prop": "hospitalId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.handleHospitalFilter,
      "clearable": "",
      "placeholder": (_vm.isOneHospital() && !_vm.addNewOrEditData.cityName) ? '请先选择城市' : '请输入'
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.hospitalName = _vm.getName(_vm.addNewOrEditData.hospitalId, _vm.remoteHospitalData, 'id', 'hospitalName');
      },
      "focus": function($event) {
        _vm.remoteHospitalData = [];
      },
      "blur": function($event) {
        _vm.remoteHospitalData = _vm.remoteHospitalDataTemp
      }
    },
    model: {
      value: (_vm.addNewOrEditData.hospitalId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "hospitalId", $$v)
      },
      expression: "addNewOrEditData.hospitalId"
    }
  }, _vm._l((_vm.remoteHospitalData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.hospitalName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), (_vm.moreThenOneHospital && !_vm.isOneHospital()) ? _c('div', _vm._l((_vm.addNewOrEditData.extendData.hospitalInfos), function(hospital, index) {
    return _c('div', {
      key: index,
      staticClass: "more-tab-div"
    }, [_c('el-row', {
      staticClass: "more-tab"
    }, [_c('el-col', [_c('el-form-item', {
      attrs: {
        "required": "",
        "prop": 'extendData.hospitalInfos.' + index + '.hospitalLevelId'
      }
    }, [_c('span', {
      staticClass: "tooltip-header-text",
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v("医院层级"), _c('common-tooltip', {
      attrs: {
        "tipCode": "9"
      }
    })], 1), _vm._v(" "), _c('el-select', {
      attrs: {
        "clearable": "",
        "placeholder": "请选择"
      },
      model: {
        value: (hospital.hospitalLevelId),
        callback: function($$v) {
          _vm.$set(hospital, "hospitalLevelId", $$v)
        },
        expression: "hospital.hospitalLevelId"
      }
    }, _vm._l((_vm.filterHospitalLevel), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "value": item.id,
          "label": item.hospitalLevel,
          "disabled": item.typeId === _vm.disableHospitalType || _vm.isSelectedHospitalLevel(item.id)
        }
      })
    }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      staticClass: "col-add-remove"
    }, [_c('el-form-item', {
      attrs: {
        "required": "",
        "label": "医院数量",
        "prop": 'extendData.hospitalInfos.' + index + '.hospitalCount'
      }
    }, [_c('el-input-number', {
      attrs: {
        "placeholder": "请输入医院数量",
        "controls": false,
        "precision": 0,
        "min": 0
      },
      model: {
        value: (hospital.hospitalCount),
        callback: function($$v) {
          _vm.$set(hospital, "hospitalCount", $$v)
        },
        expression: "hospital.hospitalCount"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "operate-add-remove"
    }, [_c('i', {
      staticClass: "iconfont icon-tianjia1",
      on: {
        "click": _vm.AddNewHospitalInfo
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-shanjian",
      on: {
        "click": function($event) {
          return _vm.removeHosiptalInfo(index)
        }
      }
    })])], 1)], 1)], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "科室",
      "prop": "offices"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择（可多选，可搜索）"
    },
    model: {
      value: (_vm.addNewOrEditData.offices),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "offices", $$v)
      },
      expression: "addNewOrEditData.offices"
    }
  }, _vm._l((_vm.baseDataRecords.Office), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.officeName
      }
    })
  }), 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "是否包含讲者",
      "prop": "includeSpeaker"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addNewOrEditData.includeSpeaker),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "includeSpeaker", $$v)
      },
      expression: "addNewOrEditData.includeSpeaker"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.addNewOrEditData.includeSpeaker == 1) ? _c('el-row', {
    staticClass: "more-tab"
  }, [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "prop": "speakerLevel"
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("讲者级别"), _c('common-tooltip', {
    attrs: {
      "tipCode": "10"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.speakerLevel),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "speakerLevel", $$v)
      },
      expression: "addNewOrEditData.speakerLevel"
    }
  }, _vm._l((_vm.filterSpeakerLevel), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.speakerLevel,
        "disabled": item.typeId === _vm.disableSpeakerType || _vm.isSelectedSpeakerLevel(item.id)
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "col-add-remove"
  }, [_c('el-form-item', {
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "讲者人数",
      "prop": "speakerCount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "placeholder": "请输入讲者人数",
      "controls": false,
      "precision": 0,
      "min": 0
    },
    model: {
      value: (_vm.addNewOrEditData.speakerCount),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "speakerCount", $$v)
      },
      expression: "addNewOrEditData.speakerCount"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-add-remove"
  }, [_c('i', {
    staticClass: "iconfont icon-tianjia1",
    on: {
      "click": _vm.AddNewSpeakerInfo
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addNewOrEditData.includeSpeaker == 1) ? _c('div', {
    staticClass: "more-tab-div"
  }, _vm._l((_vm.addNewOrEditData.extendData.speakerInfos), function(speaker, index) {
    return _c('el-row', {
      key: index,
      staticClass: "more-tab"
    }, [_c('el-col', [_c('el-form-item', {
      attrs: {
        "required": _vm.meetingSystemType != 'GSD',
        "prop": 'extendData.speakerInfos.' + index + '.speakerLevel'
      }
    }, [_c('span', {
      staticClass: "tooltip-header-text",
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v("讲者级别"), _c('common-tooltip', {
      attrs: {
        "tipCode": "10"
      }
    })], 1), _vm._v(" "), _c('el-select', {
      attrs: {
        "clearable": "",
        "placeholder": "请选择"
      },
      model: {
        value: (speaker.speakerLevel),
        callback: function($$v) {
          _vm.$set(speaker, "speakerLevel", $$v)
        },
        expression: "speaker.speakerLevel"
      }
    }, _vm._l((_vm.filterSpeakerLevel), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "value": item.id,
          "label": item.speakerLevel,
          "disabled": item.typeId === _vm.disableSpeakerType || _vm.isSelectedSpeakerLevel(item.id)
        }
      })
    }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      staticClass: "col-add-remove"
    }, [_c('el-form-item', {
      attrs: {
        "required": _vm.meetingSystemType != 'GSD',
        "label": "讲者人数",
        "prop": 'extendData.speakerInfos.' + index + '.speakerCount'
      }
    }, [_c('el-input-number', {
      attrs: {
        "placeholder": "请输入讲者人数",
        "controls": false,
        "precision": 0,
        "min": 0
      },
      model: {
        value: (speaker.speakerCount),
        callback: function($$v) {
          _vm.$set(speaker, "speakerCount", $$v)
        },
        expression: "speaker.speakerCount"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "operate-add-remove"
    }, [_c('i', {
      staticClass: "iconfont icon-tianjia1",
      on: {
        "click": _vm.AddNewSpeakerInfo
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-shanjian",
      on: {
        "click": function($event) {
          return _vm.removeSpeakerInfo(index)
        }
      }
    })])], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "参会人数（外）",
      "prop": "attendCount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "placeholder": "请输入参会人数（外）",
      "controls": false,
      "precision": 0,
      "min": 0
    },
    model: {
      value: (_vm.addNewOrEditData.attendCount),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "attendCount", $$v)
      },
      expression: "addNewOrEditData.attendCount"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "罗氏员工人数（内）",
      "prop": "rocheCount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "placeholder": "请输入罗氏员工人数（内）",
      "controls": false,
      "precision": 0,
      "min": 0
    },
    model: {
      value: (_vm.addNewOrEditData.rocheCount),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "rocheCount", $$v)
      },
      expression: "addNewOrEditData.rocheCount"
    }
  })], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "prop": "totalAmount"
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("会议总预算"), _c('common-tooltip', {
    attrs: {
      "tipCode": _vm.disableTotalAmount ? 17 : 12
    }
  })], 1), _vm._v(" "), _c('cny-input', {
    attrs: {
      "disabled": _vm.disableTotalAmount,
      "valueFixed": 2,
      "placeholder": "请输入"
    },
    on: {
      "blur": _vm.handleAmountCheck
    },
    model: {
      value: (_vm.addNewOrEditData.totalAmount),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "totalAmount", $$v)
      },
      expression: "addNewOrEditData.totalAmount"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "类型",
      "prop": "costType"
    }
  }, [_c('el-select', {
    on: {
      "change": _vm.handleCostTypeChange
    },
    model: {
      value: (_vm.addNewOrEditData.costType),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "costType", $$v)
      },
      expression: "addNewOrEditData.costType"
    }
  }, [_c('el-option', {
    attrs: {
      "value": '1',
      "label": "成本中心"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": '2',
      "label": "Real Wbs Code"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.addNewOrEditData.costType == '2') ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "Real Wbs Code",
      "prop": "wbsCode"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.wbsCode),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "wbsCode", $$v)
      },
      expression: "addNewOrEditData.wbsCode"
    }
  }, _vm._l((_vm.wbsCodeData), function(item) {
    return _c('el-option', {
      key: item.costId,
      attrs: {
        "value": item.costId,
        "label": item.costId
      }
    })
  }), 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', [(_vm.addNewOrEditData.costType == '1') ? _c('el-col', {
    staticClass: "cost-center-col"
  }, [(_vm.isMeCostCenter && !_vm.currentUserSelectVisibled) ? _c('div', {
    staticClass: "user-cost-center-field",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handlerUserCostCenterFieldClick($event)
      }
    }
  }, [_c('span', {
    staticClass: "user-cost-center-field-label"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.costCenter + ' ' + _vm.getName(_vm.addNewOrEditData.costCenter, _vm.costCenterData, 'costCenter', 'costCenterName')))]), _c('span', {
    staticClass: "current-user"
  }, [_vm._v("本人")])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "required": "",
      "label": "成本中心",
      "prop": "costCenter"
    }
  }, [_c('el-select', {
    ref: "costCenter",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    on: {
      "visible-change": _vm.handleCostCenterSelectVisibleChange,
      "change": _vm.handleCostCenterChange
    },
    model: {
      value: (_vm.addNewOrEditData.costCenter),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "costCenter", $$v)
      },
      expression: "addNewOrEditData.costCenter"
    }
  }, _vm._l((_vm.costCenterData), function(item, index) {
    return _c('el-option', {
      key: item.costCenter,
      staticClass: "edit-main-cost-center",
      attrs: {
        "value": item.costCenter,
        "label": item.costCenter + ' ' + item.costCenterName
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.costCenter + ' ' + item.costCenterName))]), _vm._v(" "), (item.isMe === '1') ? _c('span', {
      staticClass: "current-user"
    }, [_vm._v("本人")]) : _vm._e()])
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addNewOrEditData.costType == '1') ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "Statistical WBS code",
      "prop": "wbsCode"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.wbsCode),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "wbsCode", $$v)
      },
      expression: "addNewOrEditData.wbsCode"
    }
  }, _vm._l((_vm.wbsCodeData), function(item) {
    return _c('el-option', {
      key: item.costId,
      attrs: {
        "value": item.costId,
        "label": item.costId
      }
    })
  }), 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', [(_vm.addNewOrEditData.meetingSystem.length == 2) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "A1预算",
      "prop": "a1Amount"
    }
  }, [_c('cny-input', {
    attrs: {
      "valueFixed": 2,
      "placeholder": "请输入"
    },
    on: {
      "blur": _vm.handleAmountCheck
    },
    model: {
      value: (_vm.addNewOrEditData.a1Amount),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "a1Amount", $$v)
      },
      expression: "addNewOrEditData.a1Amount"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addNewOrEditData.meetingSystem.length == 2) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "GSD预算",
      "prop": "gsdAmount"
    }
  }, [_c('cny-input', {
    attrs: {
      "valueFixed": 2,
      "placeholder": "请输入"
    },
    on: {
      "blur": _vm.handleAmountCheck
    },
    model: {
      value: (_vm.addNewOrEditData.gsdAmount),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "gsdAmount", $$v)
      },
      expression: "addNewOrEditData.gsdAmount"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议申请人",
      "prop": "meetingOrganizerId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.handleMeetingOrganizerFilter,
      "clearable": "",
      "placeholder": "请输入"
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.meetingOrganizerName = _vm.getName(_vm.addNewOrEditData.meetingOrganizerId, _vm.remoteMeetingOrganizerData, 'Id', 'AD');
        _vm.addNewOrEditData.meetingOrganizerCnname = _vm.getName(_vm.addNewOrEditData.meetingOrganizerId, _vm.remoteMeetingOrganizerData, 'Id', 'CName');
        _vm.remoteMeetingOrganizerData = []
      }
    },
    model: {
      value: (_vm.addNewOrEditData.meetingOrganizerId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingOrganizerId", $$v)
      },
      expression: "addNewOrEditData.meetingOrganizerId"
    }
  }, _vm._l((_vm.remoteMeetingOrganizerData), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "value": item.Id,
        "label": item.CName + ' ' + item.AD
      }
    })
  }), 1)], 1)], 1)], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-info"
  }, [(!_vm.waitBack) ? _c('div', {
    staticClass: "bottom-info-operate"
  }, [(_vm.editType != 'edit') ? _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v("删除")]) : _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleDeleteClick()
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handlerSave
    }
  }, [_vm._v("保存")])], 1) : _vm._e()]), _vm._v(" "), _c('common-confirm', {
    attrs: {
      "dialogVisiable": _vm.confirmSaveVisible,
      "confirm": _vm.handlerSaveConfirmOK
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.confirmSaveVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.confirmSaveVisible = $event
      }
    }
  }, [_c('div', [_vm._v("\n          确认保存会议？\n      ")]), _vm._v(" "), (_vm.isSeasonlyType) ? _c('div', [_vm._v("\n          该季度的计划申请，需要直线经理和二级审批人审批\n      ")]) : _c('div', [_vm._v("\n          " + _vm._s(_vm.monthlyTypeMessage) + "\n      ")])]), _vm._v(" "), _c('common-confirm', {
    attrs: {
      "dialogVisiable": _vm.confirmDeleteVisible,
      "confirm": _vm.handlerDeleteConfirmOK
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.confirmDeleteVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.confirmDeleteVisible = $event
      }
    }
  }, [_c('div', [_vm._v("\n          确认删除会议？\n      ")])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3ddf5019", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ddf5019","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/meetingplan/application/edit/index.vue
// module id = 1564
// module chunks = 7